import { StopTankerReportMode } from '../../report.models';
import { toEnglishDigits } from '../../report.utils';
import { StopTankerReportColumn, StopTankerReportRow } from './stop-tanker-report.models';

export const STOP_TANKER_PAGE_SIZE = 20;
export const STOP_TANKER_PAGE_SIZE_OPTIONS = [10, 20, 50];

const COLUMNS: Record<StopTankerReportMode, StopTankerReportColumn[]> = {
  'vehicle-refueling': [
    { field: 'strDate', title: 'تاریخ' },
    { field: 'strTime', title: 'ساعت' },
    { field: 'fLiter', title: 'سوخت (litre)', format: 'number', total: true, unit: 'لیتر' },
    { field: 'iCost', title: 'هزینه (تومان)', format: 'number', total: true, unit: 'تومان' },
    { field: 'iKm', title: 'پیمایش (km)', format: 'number' },
    { field: 'IDefKM', title: 'پیمایش نسبت به قبل (km)', format: 'number' },
    { field: 'fConsumption', title: 'متوسط مصرف (litre/100)', format: 'number' },
  ],
  stop: [
    { field: 'strFullName', title: 'نام خودرو' },
    { field: 'strDate', title: 'تاریخ' },
    { field: 'strSTime', title: 'زمان شروع' },
    { field: 'strETime', title: 'زمان پایان' },
    { field: 'strParkTime', title: 'زمان توقف' },
    { field: 'strAddress', title: 'آدرس' },
  ],
  'tanker-feeding': [
    { field: 'strTitle', title: 'محل تامین' },
    { field: 'fFeedingValue', title: 'حجم کل تغذیه', format: 'number', unit: 'لیتر' },
    { field: 'iCount', title: 'تعداد تغذیه', format: 'number' },
  ],
  'tanker-discharge': [
    { field: 'strDate', title: 'تاریخ' },
    { field: 'strSTime', title: 'ساعت شروع' },
    { field: 'strETime', title: 'ساعت پایان' },
    { field: 'fDischargeValue', title: 'مقدار تخلیه', format: 'number', total: true, unit: 'لیتر' },
    { field: 'iSpeed', title: 'سرعت', format: 'number' },
    { field: 'strAddress', title: 'آدرس' },
  ],
  'tanker-refueling': [
    { field: 'strFullName', title: 'نام خودرو' },
    { field: 'strDateTime', title: 'تاریخ' },
    { field: 'fValue', title: 'مقدار', format: 'number', total: true, unit: 'لیتر' },
    { field: 'strAddress', title: 'آدرس' },
  ],
  'tanker-suspicious-discharge': [
    { field: 'strFullName', title: 'نام خودرو' },
    { field: 'strDateTime', title: 'تاریخ' },
    { field: 'fValue', title: 'مقدار', format: 'number', total: true, unit: 'لیتر' },
    { field: 'strAddress', title: 'آدرس' },
  ],
};

export function getStopTankerColumns(mode: StopTankerReportMode): StopTankerReportColumn[] {
  return COLUMNS[mode];
}
export function getStopTankerExportColumns(mode: StopTankerReportMode): StopTankerReportColumn[] {
  if (mode !== 'vehicle-refueling') return COLUMNS[mode];
  return [...COLUMNS[mode],
    { field: 'strMobileDomain_strComment', title: 'حوزه خدمت' },
    { field: 'strMobileGroup_strComment', title: 'گروه' },
    { field: 'strMobileType_strComment', title: 'نوع' },
    { field: 'strVehicleNo', title: 'پلاک' },
    { field: 'strFullName', title: 'نام راننده' },
    { field: 'fLat', title: 'عرض جغرافیایی', format: 'number' },
    { field: 'fLon', title: 'طول جغرافیایی', format: 'number' },
    { field: 'strMobile', title: 'شماره موبایل راننده' },
  ];
}

export function buildStopTankerSearchIndex(row: StopTankerReportRow): string {
  return toEnglishDigits(Object.entries(row)
    .filter(([key]) => key !== 'searchIndex')
    .map(([, value]) => value ?? '')
    .join(' ')).toLowerCase();
}

export function getStopTankerTotal(rows: StopTankerReportRow[], field: keyof StopTankerReportRow): number {
  return rows.reduce((total, row) => total + (Number(row[field]) || 0), 0);
}
